import { render, staticRenderFns } from "./NewsCardDate.vue?vue&type=template&id=75facae6&scoped=true&"
import script from "./NewsCardDate.vue?vue&type=script&lang=js&"
export * from "./NewsCardDate.vue?vue&type=script&lang=js&"
import style0 from "./NewsCardDate.vue?vue&type=style&index=0&id=75facae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75facae6",
  null
  
)

export default component.exports